import { http } from 'shared/api/http';

const BASE = '/api/v1/pilates/settings/plans'; // ✅ DOĞRU

export const plansApi = {
  list() {
    return http(BASE, { method: 'GET' });
  },
  create(payload) {
    return http(BASE, { method: 'POST', body: payload });
  },
  update(id, payload) {
    return http(`${BASE}/${id}`, { method: 'PUT', body: payload });
  },
  setActive(id, active) {
    // controller: @PutMapping("/plans/{id}/active")
    return http(`${BASE}/${id}/active`, { method: 'PUT', body: { active } });
  },
};
